import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utils/request.js'

import {Message} from 'element-ui'
import * as Urls from '../../src/components/url'

const imUrl = Urls.baseurl+'/api/visitor/im'
const woUrl = Urls.baseurl+'/api/visitor/wo'
const baseurl = Urls.baseurl
export default {
    getUserNickNames(visitorMd5Code, callback) {
      var vm = this
      axios.get(imUrl + '/nickNamePool?visitorMd5Code=' + visitorMd5Code).then((response) => {
        console.log(response, "获取入口response")
        callback(response.data)
      }, (err) => {
        console.log(err)
      })
    },
    getHttp(visitorMd5Code,callback){
        var vm = this;
        axios.get(imUrl + '/image-prefix?visitorMd5Code=' + visitorMd5Code).then((response) => {
          console.log(response, "获取入口response")
          callback(response.data)
        }, (err) => {
          console.log(err)
        })
    },
    getOverSession (visitorMd5Code,callback) {
        var vm = this;
        axios.get(imUrl + '/session-timeout?visitorMd5Code='+visitorMd5Code).then((response) => {
          console.log(response, "获取入口response")
          callback(response.data)
        }, (err) => {
          console.log(err)
        })
    },
    entrance (visitorMd5Code, callback) {
        var vm = this;
        axios.get(imUrl + '/entrance?visitorMd5Code='+visitorMd5Code).then((response) => {
            console.log(response, "获取入口response")
            callback(response.data)
        }, (err) => {
            console.log(err)
        })
    },
    queryEnterQueue (visitorMd5Code, entranceId, callback) { // 访客排队
        var vm = this;
        //let params = entranceId ? {entranceId: entranceId} : {}
        //console.log(visitorMd5Code, entranceId, callback,"queryEnterQueue")
        axios.get(imUrl + '/inLine?visitorMd5Code='+visitorMd5Code+'&entranceId='+entranceId).then((response) => {
            // Message({
            //     showClose: true,
            //     message: '访客排队response',
            //     type: 'success'
            // });
            console.log(response, "访客排队response")
            callback(response.data)

        }, (err) => {
            console.log(err)

        })
    },

    getSessionStatus (visitorMd5Code, callback) { // 获取当前IM会话状态
        axios.get(imUrl + '/sessionStatus?visitorMd5Code='+visitorMd5Code).then((response) => {

            console.log(response, "获取当前IM会话状态response")
            callback(response.data)

        }, (err) => {
            console.log(err)
        })
    },
    getPositionAndSessionStatus (obj, callback) { // 获取访客当前位置
        //console.log(obj,"obj");
        axios.get(imUrl + '/getPositionAndSessionStatus?visitorMd5Code='+obj.visitorMd5Code).then((response) => {

            console.log(response, "获取当前排队位置");
            callback(response.data)
            // commit('SET_PROJECT_LIST', { list: response.data })
        }, (err) => {
            console.log(err)
        })
    },
    cancelWait (visitorMd5Code, callback) {  // 取消排队
        axios.get(imUrl + '/cancelWait?visitorMd5Code='+visitorMd5Code).then((response) => {

            console.log(response, "取消排队");
            callback(response.data)
        }, (err) => {
            console.log(err)
        })
    },
    lastMessage (visitorMd5Code, offsetSeq, sessionId, callback) { // 获取聊天记录
        let md5 = visitorMd5Code ? visitorMd5Code : '';
        let seq = offsetSeq ? offsetSeq : '';
        let id = sessionId ? sessionId : '';
        axios.get(imUrl + '/lastMessage?visitorMd5Code='+md5+'&offsetSeq='+seq+'&sessionId='+id).then((response) => {

            //console.log(response, "获取聊天记录");
            callback(response.data)

        }, (err) => {
            console.log(err)
        })
    },
    getAutoReply (visitorMd5Code, callback) {
        // let body = {
        //   "code": 1,
        //   "message": "OK",
        //   "data": {
        //     "id": 1000,
        //     "gmtCreate": "2017-02-16 08:40:44",
        //     "gmtModified": "2017-04-18 10:14:16",
        //     "comId": 1000,
        //     "welcomeMsg": "你终于来了11",
        //     "finishedMsg": "下次再来二二二v地方大幅度地方的fdfdfdfd11111221111",
        //     "visitorTimeout": 60,
        //     "visitorTimeoutMsg": "访客很久没有说话了呀！",
        //     "userTimeout": 62,
        //     "userTimeoutMsg": "客服吃饭去了呀",
        //     "forceIssueType": false,
        //     "popCsr": false,
        //     "visitorTimeoutFlag": true,
        //     "userTimeoutFlag": false
        //   }
        // }
        // setTimeout(() => callback(body), 100)

        axios.get(imUrl + '/getAutoReply?visitorMd5Code='+visitorMd5Code).then((response) => {
            console.log(response, "获取自动聊天消息");
            callback(response.data)
        }, (err) => {
            console.log(err)
        })
    },
    sendMessage (visitorMd5Code, obj, callback) {
        axios.post(imUrl + '/imMessage?visitorMd5Code='+visitorMd5Code,obj).then((response) => {
            console.log(response, "向后台发送消息");
            callback(response.data)
        }, (err) => {
            console.log(err)
        })
    },
    sendAutoMessage (visitorMd5Code, obj,callback) {
        console.log(obj, '自动消息请求')
        axios.post(imUrl + '/autoMessage?visitorMd5Code='+visitorMd5Code,obj).then((response) => {
            console.log(response, "向后台发送自动消息");
            callback(response.data)
        }, (err) => {
            console.log(err)
        })
    },
    satisfySetting (visitorMd5Code, callback) {
        axios.get(imUrl + '/satisfySetting?visitorMd5Code='+visitorMd5Code).then((response) => {

            console.log(response, "获取满意度蛇者");
            callback(response.data)

        }, (err) => {
            console.log(err)
        })
    },
    workOrderSubmittied (visitorMd5Code,workOrderId, orderName, callback) {
        let obj = {}
        orderName=encodeURI(orderName);
        axios.post(imUrl + '/workOrderSubmitted/'+workOrderId+'?visitorMd5Code='+visitorMd5Code+'&orderName='+orderName,obj).then((response) => {
            console.log(response, "工单提交成功通知");
            callback(response.data)

        }, (err) => {
            console.log(err)
        })
    },
    evaluate (obj, callback) {
         axios.post(imUrl + '/evaluate?visitorMd5Code='+obj.visitorMd5Code,obj.form).then((response) => {
            console.log(response, "发送满意度评价");
            callback(response.data)

        }, (err) => {
            console.log(err)
        })
    },
    getinvitations(visitorMd5Code, callback){
        axios.get(baseurl+'/api/visitor/initiative-invite/invitations?visitorMd5Code='+visitorMd5Code).then(function (response) {
          callback(response.data)
        }, function (errorMessage) {
          console.log(errorMessage)
        })
      },
    sendTransientMessage (obj,callback) {
        axios.post(imUrl + '/transientMessage?visitorMd5Code='+obj.visitorMd5Code,obj.form).then((response) => {
            console.log(response, "正在输入的消息");
            callback(response.data)

        }, (err) => {
            console.log(err)
        })
    },
    sendImgMsg (visitorMd5Code, formData, callback) {
        console.log(formData)
        axios.post(imUrl + '/fileUpload?visitorMd5Code='+visitorMd5Code,formData).then((response) => {
            console.log(response, "发送图片消息");
            callback(response.data)
        }, (err) => {
            console.log(err)
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/imApi.js